import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import './VisitorStickerPrint.css';

const VisitorStickerPrint = props => {
  const {
    contactname,
    companyname,
    showActions,
    onPrinted,
    onClear
  } = props;

  const handlePrint = () => {
    document.body.classList.add('visitor-sticker-printing');
    window.print();
    window.setTimeout(() => {
      document.body.classList.remove('visitor-sticker-printing');
      if (onPrinted) {
        onPrinted();
      }
    }, 500);
  };

  return (
    <div className="visitor-sticker-print-root">
      <div className="visitor-sticker-print-area visitor-sticker">
        <div className="visitor-sticker-name">{contactname || '—'}</div>
        <div className="visitor-sticker-company">{companyname || '—'}</div>
      </div>
      {showActions && (
        <div className="visitor-sticker-actions">
          <Button
            color="primary"
            startIcon={<PrintIcon />}
            variant="contained"
            onClick={handlePrint}
          >
            Print
          </Button>
          {onClear && (
            <Button variant="outlined" onClick={onClear}>
              Clear
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

VisitorStickerPrint.propTypes = {
  contactname: PropTypes.string,
  companyname: PropTypes.string,
  showActions: PropTypes.bool,
  onPrinted: PropTypes.func,
  onClear: PropTypes.func
};

VisitorStickerPrint.defaultProps = {
  contactname: '',
  companyname: '',
  showActions: true,
  onPrinted: null,
  onClear: null
};

export default VisitorStickerPrint;
